import _ from 'lodash'
import { formatNumber } from 'core/service/lib/number-format'
import { connect } from 'react-redux'
import { getInvestmentBenefit } from './selectors'
import { getLegalDisclaimerEndDate } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getcoveragePlanStartDate } from 'quick-quote/product-common/coverage-plan/selectors'
import { getSelectedDisplayProductNameThai } from 'quick-quote/product-selection/selectors'
import MESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'
import { WordWraps } from 'common-components'
import Mustache from 'mustache'

export const _InvestmentBenefitTable = ({ investmentBenefit, displayProduct, policyValue }) => {
  const getRemarkBulletByProductCode = () => {
    if (Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(displayProduct.code)) {
      return [
        MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_2_25_5,
        MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_3_25_5,
        MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_4_25_5
      ]
    } else if (Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(displayProduct.code)) {
      return [
        MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_2_15_8,
        MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_3_15_8,
        MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_4_15_8
      ]
    }
    return [
      MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_2_25_5,
      MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_3_25_5,
      MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_4_25_5
    ]
  }
  return (
    <div className="group example table-no-padding bold-last-child" id="investment-benefit">
      <h3 className="name">
        <span className="example-name" style={{ display: 'none' }}>
          สรุปผลประโยชน์ตามมูลค่ากรมธรรม์
        </span>
        {MESSAGES.INVESTMENT_BENEFITS}
      </h3>
      <div className="dividend-table">
        <table>
          <thead>
            <tr>
              <td rowSpan={2}>{MESSAGES.INVESTMENT_BENEFITS_SUMMARY}</td>
            </tr>
            <tr>
              <td width="20%">
                <div>{MESSAGES.EXAMPLE_1}</div>
                <div>
                  {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
                  {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_LOW}
                </div>
              </td>
              <td width="20%">
                <div>{MESSAGES.EXAMPLE_2}</div>
                <div>
                  {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
                  {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_MIDDLE}
                </div>
              </td>
              <td width="20%">
                <div>{MESSAGES.EXAMPLE_3}</div>
                <div>
                  {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
                  {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_HIGH}
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            {investmentBenefit.guaranteeBenefits.map((v, k) => (
              <InvestmentBenifitComponent datas={v} key={`guarantee_benefit_${k}`} />
            ))}
          </tbody>
          <tbody>
            {investmentBenefit.nonGuaranteeBenefits.map((v, k) => (
              <InvestmentBenifitComponent datas={v} key={`no_guarantee_benefit_${k}`} />
            ))}
          </tbody>
        </table>
      </div>
      <br />
      <div className="disclaimer">
        {Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(displayProduct.code) && (
          <>
            <ul className="dash">
              <li>{Mustache.render(MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.EXPENSE_RATIO, {
                value: policyValue.expenseRatio
              })}</li>
            </ul>
            <br />
          </>
        )}
        <text className="head">{MESSAGES.NOTE}</text>
        <ul className="dash">
          <li>
            {MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_1}
            <span style={{ display: 'block', marginTop: '5px' }}>
              <WordWraps>{getRemarkBulletByProductCode()[0]}</WordWraps>
            </span>
          </li>
          <li>
            <div>
              {getRemarkBulletByProductCode()[1]}
            </div>
            <div>
              {MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_3_2}
            </div>
          </li>
          <li>
            {MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_4}
            <ol>
              {MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_4_SUB.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ol>
            {MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_4_UNDER_SUB}
          </li>
          <li>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_5}</li>
        </ul>
        <br />
        <text className="head">
          {MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.TITLE}
        </text>
        <ul className="dash">
          <li>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_0}</li>
          <li>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_1}</li>
          <li>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_2}</li>
          <li>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_3}</li>
          <li>{getRemarkBulletByProductCode()[2]}</li>
          <li>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_5}</li>
          <li>
            {MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6}
            <ol>
              <li>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_1}</li>
              <li>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_2}</li>
            </ol>
          </li>
          <text>{MESSAGES.INDEX_LINKED_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_3}</text>
        </ul>
        <br />
      </div>
    </div>
  )
}

const InvestmentBenifitComponent = ({ datas }) => {
  if (datas.title === MESSAGES.INVESTMENT_BENEFITS_NONGUARANTEE_MATURITY) {
    return (
      <tr>
        <td>
          3&#41;{' '}
          <text style={{ color: '#2425aa', fontSize: '24px' }}>
            {MESSAGES.TERM_LIFE_BENEFITS_NONGUARANTEE_MATURITY_1}
          </text>
          {MESSAGES.TERM_LIFE_BENEFITS_NONGUARANTEE_MATURITY_2}
        </td>
        {/* <Amount amount={datas.guaranteeValue} /> */}
        {datas.rates.map((v, k) => (_.isNumber(v) ? <Amount amount={v} key={k} /> : <td>{v}</td>))}
      </tr>
    )
  } else if (datas.title === MESSAGES.INVESTMENT_BENEFITS_NONGUARANTEE_TOTAL) {
    return (
      <tr>
        <td>
          {MESSAGES.TERM_LIFE_BENEFITS_NONGUARANTEE_TOTAL_1}{' '}
          <text style={{ color: '#2425aa', fontSize: '24px' }}>{MESSAGES.TERM_LIFE_BENEFITS_NONGUARANTEE_TOTAL_2}</text>
        </td>
        {/* <Amount amount={datas.guaranteeValue} /> */}
        {datas.rates.map((v, k) => (_.isNumber(v) ? <Amount amount={v} key={k} /> : <td>{v}</td>))}
      </tr>
    )
  } else {
    return (
      <tr>
        <td>
          {datas.title.split('\n').map((line, index) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))}
        </td>
        {/* <Amount amount={datas.guaranteeValue} /> */}
        {datas.rates.map((v, k) => (_.isNumber(v) ? <Amount amount={v} key={k} /> : <td>{v}</td>))}
      </tr>
    )
  }
}

const Amount = ({ amount }) => <td>{formatNumber(amount, 2, true)}</td>

const mapStateToProps = (state) => ({
  investmentBenefit: getInvestmentBenefit(state),
  legalDisclaimerEndDate: getLegalDisclaimerEndDate(state),
  coveragePlanStartDate: getcoveragePlanStartDate(state),
  productName: getSelectedDisplayProductNameThai(state),
})
export default connect(mapStateToProps)(_InvestmentBenefitTable)
